"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOmise = exports.checkCreateTokenError = void 0;
var react_1 = require("react");
var useOmiseScript_1 = require("./useOmiseScript");
var checkCreateTokenError = function (status, response) {
    if (status === 200)
        return null;
    if (response.card && !response.card.security_code_check) {
        return 'Incorrect security code';
    }
    if (response.object === 'error') {
        return response.message;
    }
    return 'Unknown error';
};
exports.checkCreateTokenError = checkCreateTokenError;
var useOmise = function (_a) {
    var publicKey = _a.publicKey, scriptType = _a.scriptType;
    var _b = react_1.useState(null), createTokenFn = _b[0], setCreateTokenFn = _b[1];
    var _c = react_1.useState(null), createSourceFn = _c[0], setCreateSourceFn = _c[1];
    var _d = react_1.useState(null), createTokenPromiseFn = _d[0], setCreateTokenPromiseFn = _d[1];
    var _e = react_1.useState(null), createSourcePromiseFn = _e[0], setCreateSourcePromiseFn = _e[1];
    var _f = useOmiseScript_1.useOmiseScript(scriptType), loadingScript = _f[0], errorLoadingScript = _f[1];
    react_1.useEffect(function () {
        if (window.Omise) {
            window.Omise.setPublicKey(publicKey);
        }
    }, [publicKey, loadingScript]);
    react_1.useEffect(function () {
        if (window.Omise) {
            var Omise = window.Omise;
            var omiseCreateToken_1 = Omise.createToken.bind(Omise);
            var omiseCreateSource_1 = Omise.createSource.bind(Omise);
            var createToken = function () { return omiseCreateToken_1; };
            var createSource = function () { return omiseCreateSource_1; };
            // Promisify the original createToken function.
            var createTokenPromise = function () {
                return function (as, attributes) {
                    return new Promise(function (resolve, reject) {
                        omiseCreateToken_1(as, attributes, function (status, response) {
                            var hasError = exports.checkCreateTokenError(status, response);
                            if (hasError) {
                                reject(response);
                            }
                            else {
                                resolve(response === null || response === void 0 ? void 0 : response.id);
                            }
                        });
                    });
                };
            };
            // Promisify the original createSource function.
            var createSourcePromise = function () {
                return function (type, attributes) {
                    return new Promise(function (resolve, reject) {
                        omiseCreateSource_1(type, attributes, function (status, response) {
                            if (status !== 200) {
                                reject(response);
                            }
                            else {
                                resolve(response === null || response === void 0 ? void 0 : response.id);
                            }
                        });
                    });
                };
            };
            setCreateTokenFn(createToken);
            setCreateSourceFn(createSource);
            setCreateTokenPromiseFn(createTokenPromise);
            setCreateSourcePromiseFn(createSourcePromise);
        }
    }, [loadingScript]);
    return {
        loading: loadingScript,
        loadingError: errorLoadingScript,
        createToken: createTokenFn,
        createTokenPromise: createTokenPromiseFn,
        createSourcePromise: createSourcePromiseFn,
        checkCreateTokenError: exports.checkCreateTokenError,
        createSource: createSourceFn,
    };
};
exports.useOmise = useOmise;
